import {IOn2ServerConfig, ISlsOrd} from "./slsordClient";
import {User} from "../context/userContext";


interface ICustomer {
    name: string;
    firstName: string;
    lastName: string;
    email:string;
    phone:string;
    id?:number;
}
interface IFavoriteResponse {
    customerId: number;
    favorites: number[];
}
class CustomerClient {
    constructor(private readonly config:IOn2ServerConfig) {

    }

    /**
     *
     * @param phone Needs to strictly follow syntax (xxx) xxx-xxxx (due to Kova)
     */
    async findCustomerByPhone(communityId:string, phone:string): Promise<User|null> {

        const res = await fetch(this.config.serverUri + communityId + "/customer?phone=" + encodeURIComponent(phone));
        if (res.status === 204) {
            return null;
        }
        const resJson = await res.json() as ICustomer;
        if (resJson !== null) {
            return resJson;
        }
        return null;
    }

    async getFavorites(userId:number) {
        const res = await fetch(this.config.serverUri + "customer/" + userId + "/favorites");
        const resJson = await res.json() as IFavoriteResponse;
        return resJson.favorites;
    }

    async updateFavorites(userId:number, favorites:number[]) {
        return await fetch(this.config.serverUri + "customer/" + userId + "/favorites", { method: "POST", body: JSON.stringify(favorites), headers: { "Content-Type": "application/json"}});
    }

    async register(community:string, firstName: string, lastName: string, email:string, phone: string) {
        let customer: ICustomer = {
            email,
            name: `${lastName}, ${firstName}`,
            firstName,
            lastName,
            phone
        };
        const response = await fetch(this.config.serverUri + `${community}/customer`, {method: "POST", headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }, body: JSON.stringify(customer)});
        return await response.json() as ICustomer;
    }
}
export default CustomerClient;